import * as dom from './ui/dom';
import * as state from './core/state';
import { client } from './core/mqtt';
import { generateKeyPair } from './core/crypto';
import { initModal } from './ui/modal';
import { renderConversationList } from './ui/render';
import { initSoundboard } from './ui/soundboard';

// --- Friend Request Logic ---

function requestPublicKey(targetFingerprint: string, friendName: string) {
    if (!state.userFingerprint || !state.userPublicKey) {
        console.warn('Cannot request public key: User identity not set.');
        return;
    }
    state.pendingPublicKeyRequests.set(targetFingerprint, friendName);
    const requestMessage = {
        type: 'requestPublicKey',
        senderFingerprint: state.userFingerprint,
        senderName: state.userName,
        targetFingerprint: targetFingerprint
    };
    client.publish('bambi/request_key', JSON.stringify(requestMessage), (err) => {
        if (err) console.error('Error publishing public key request:', err);
        else console.log(`Published public key request for fingerprint: ${targetFingerprint}`);
    });
}

dom.requestPublicKeyButton.addEventListener('click', () => {
    const friendName = dom.friendNameInput.value.trim();
    const friendFingerprint = dom.friendFingerprintInput.value.trim();
    if (friendName && friendFingerprint) {
        requestPublicKey(friendFingerprint, friendName);
        state.setFriendFingerprintToFilter(friendFingerprint);
        dom.friendNameInput.value = '';
        dom.friendFingerprintInput.value = '';
    } else {
        console.warn('Please enter both a friend\'s name and fingerprint.');
    }
});


// --- Initial Setup ---

initModal();
if (!state.userKeyPair) {
    generateKeyPair();
}
dom.currentTopicDisplay.textContent = state.userFingerprint || 'None';
renderConversationList();
initSoundboard();